import { z } from "zod";

export const PublicServiceCategorySchema = z.object({
    id: z.number(),
    name: z.string(),
    slug: z.string(),
    expert_count: z.number().optional().nullable().default(0),
});

export const PublicServiceCategoryWithSubcategoriesSchema = z.object({
    id: z.number(),
    name: z.string(),
    slug: z.string(),
    expert_count: z.number().optional().nullable().default(0),
    subcategories: z.array(PublicServiceCategorySchema),
});

export const GroupedServiceCategorySchema = z.object({
    group_name: z.string().nullable(),
    categories: z.array(PublicServiceCategoryWithSubcategoriesSchema),
});

export const GroupedServiceCategoryTreeSchema = z.array(GroupedServiceCategorySchema);

export const AdminSubcategorySchema = z.object({
    id: z.number(),
    name: z.string(),
    slug: z.string(),
});

export const AdminCategorySchema = z.object({
    id: z.number(),
    group_name: z.string().nullable(),
    name: z.string(),
    slug: z.string(),
    subcategories: z.array(AdminSubcategorySchema),
});

export const AdminCategoryTreeSchema = z.array(AdminCategorySchema);

export const AdminCategoryCreateResponseSchema = z.object({
    id: z.number(),
    group_name: z.string().nullable(),
    name: z.string(),
    slug: z.string(),
});

export const AdminSubcategoryCreateResponseSchema = z.object({
    id: z.number(),
    category_id: z.number(),
    name: z.string(),
    slug: z.string(),
});

export type AdminCategory = z.infer<typeof AdminCategorySchema>;
export type AdminSubcategory = z.infer<typeof AdminSubcategorySchema>;
export type AdminCategoryCreateResponse = z.infer<typeof AdminCategoryCreateResponseSchema>;
export type AdminSubcategoryCreateResponse = z.infer<typeof AdminSubcategoryCreateResponseSchema>;
export type PublicServiceCategory = z.infer<typeof PublicServiceCategorySchema>;
export type PublicServiceCategoryWithSubcategories = z.infer<typeof PublicServiceCategoryWithSubcategoriesSchema>;
export type GroupedServiceCategory = z.infer<typeof GroupedServiceCategorySchema>;
